import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

type StyleProps = {
  isDisabled: boolean
}

const mainWrapperStyles = ({ theme, isDisabled }: Theme & StyleProps) => css`
  label: price-range__main-wrapper;

  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: ${theme.spacings.bit};

  & > div {
    display: flex;
    align-items: center;
    margin: ${theme.spacings.bit};
  }

  ${theme.media.mega} {
    padding-right: ${theme.spacings.kilo};
  }

  input {
    padding: ${theme.spacings.kilo} ${theme.spacings.byte};
  }

  svg {
    fill: ${isDisabled ? theme.colors.n300 : theme.colors.white};
  }
`

export const MainWrapper = styled('div')(mainWrapperStyles)
